import { invalidateQueries } from '@/utils/tanstack';
import { GET_USER_SESSION_QUERY_KEY } from './types';

export const invalidateUserSessionQuery = () => {
  invalidateQueries([GET_USER_SESSION_QUERY_KEY])
    .then()
    .catch(() => undefined);
};
